// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from '@/extlib/vue';
import App from './app';
// import yxpapi from '@/extlib/yxpapi';
// import '@/components/common/globalComp'; // 自定义全局组件
Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.config.productionTip = false;
/* eslint-disable no-new */
Object.assign(Vue.prototype.$ELEMENT, {
    size: 'medium',
    zIndex: 3000,
});
new Vue({
    el: '#yxpSystemManage',
    components: { App },
    template: '<App/>',
});
